module.exports = __webpack_public_path__ + "img/logo_inpurchase.0a4944bc.png";